import { useState, useEffect } from "react";

export function useDebounceHook(value: any, delay: number) {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(
        () => {
            // Set debouncedValue to value (passed in) after the specified delay
            const handler = setTimeout(() => {
                setDebouncedValue(value);
            }, delay);

            return () => {
                clearTimeout(handler);
            };
        },
        [value]
    );
    return debouncedValue;
}

export function useOnClickOutside(ref, handler) {
    useEffect(
      () => {
        const listener = event => {
          // Do nothing if clicking ref's element or descendent elements
          if (!ref.current || ref.current.contains(event.target)) {
            return;
          }

          handler(event);
        };

        document.addEventListener('focus', listener);
        document.addEventListener('touchstart', listener);

        return () => {
          document.removeEventListener('focus', listener);
          document.removeEventListener('touchstart', listener);
        };
      },
      [ref, handler]
    );
  }


// WEBPACK FOOTER //
// ./src/components/AddressAutoComplete/Hooks.ts